// src/context/PythonContext.jsx
import { createContext, useContext, useState, useCallback } from "react";

const PythonCtx = createContext({ py: null, loadPy: () => Promise.resolve() });

export function PythonProvider({ children }) {
  const [py, setPy] = useState(null);
  const [loading, setLoading] = useState(false);

  /** Lazy-load Pyodide the first time someone calls loadPy() */
  const loadPy = useCallback(async () => {
    if (py || loading) return;           // already ready or in flight
    setLoading(true);

    try {
      const { loadPyodide } = await import(
        /* webpackIgnore: true */
        "https://cdn.jsdelivr.net/pyodide/v0.26.0/full/pyodide.mjs"
      );
      const pyodide = await loadPyodide({
        indexURL: "https://cdn.jsdelivr.net/pyodide/v0.26.0/full/",
      });
      setPy(pyodide);
    } catch (err) {
      console.error("Pyodide failed to load:", err);
    } finally {
      setLoading(false);
    }
  }, [py, loading]);

  return (
    <PythonCtx.Provider value={{ py, loadPy }}>
      {children}
    </PythonCtx.Provider>
  );
}

export const usePy = () => useContext(PythonCtx);
